<mat-dialog-content>
  <h2>{{ "campaign.outcomes.generator.title" | translate }}</h2>
  <div class="generator-container">
    <p>{{ "campaign.outcomes.generator.description" | translate }}</p>

    <mat-radio-group [(ngModel)]="mode" (change)="onModeChange()" class="mode-selector">
      <mat-radio-button value="score">{{ "campaign.outcomes.generator.score-based" | translate }}</mat-radio-button>
      <mat-radio-button value="answer">{{ "campaign.outcomes.generator.answer-based" | translate }}</mat-radio-button>
    </mat-radio-group>

    <div class="settings-container">
      <mat-form-field appearance="outline">
        <mat-label>{{ "campaign.outcomes.generator.number-of-outcomes" | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="numberOfOutcomes" min="1" [max]="maxOutcomes" />
        <mat-hint>Max: {{ maxOutcomes }}</mat-hint>
      </mat-form-field>
    </div>

    @if (mode === "score") {
      <div class="preview-info">
        <p>Range: {{ data.minScore }} - {{ data.maxScore }}</p>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="secondary-button" (click)="cancel()">{{ "generic.cancel" | translate }}</button>
  <button mat-flat-button color="primary" (click)="generate()">{{ "generic.generate" | translate }}</button>
</mat-dialog-actions>
